import { create } from 'zustand'
import { platform } from '@/platform'
import { A11Y_STORAGE_KEY, applyA11y, parseA11y, type AccessibilityPrefs } from '@/lib/accessibility'

/* Spec PWA-001 — tela 19: preferencias de acessibilidade salvas no aparelho e aplicadas na raiz do documento. */

type AccessibilityState = AccessibilityPrefs & {
    update: (patch: Partial<AccessibilityPrefs>) => void
}

const initial = parseA11y(platform.storage.get(A11Y_STORAGE_KEY))
applyA11y(initial)

export const useAccessibilityStore = create<AccessibilityState>((set, get) => ({
    ...initial,
    update: (patch) => {
        const { update: _ignored, ...current } = get()
        const next = { ...current, ...patch }
        platform.storage.set(A11Y_STORAGE_KEY, JSON.stringify(next))
        applyA11y(next)
        set(patch)
    },
}))
